export enum PrimeFlexSizes {
    sm,
    md,
    lg,
    xl
}